import { IGridFile } from '../../redux/file/fileTypes'
import { MSAL_ERROR_MESSAGES } from '../../utils/constants'

// Function to get all distinct mime types from an array of grid files
export const getAllDistinctMimeTypes = (gridFiles: IGridFile[]) => {
  const mimeTypesSet = new Set<string>()
  for (let i = 0; i < gridFiles.length; i++) {
    mimeTypesSet.add(gridFiles[i].mimeType || '')
  }
  return Array.from(mimeTypesSet).map((file: string) => ({
    value: file,
    name: file,
  }))
}

// Reusable sorting function
export const sortByKeyDescending = <T>(data: T[], key: keyof T) =>
  data.sort((a, b) => (b[key] as any) - (a[key] as any))

// Exporting the functions

export const formatDate = (timestamp?: string | number) => {
  if (!timestamp) return 'N/A'
  const date = new Date(Number(timestamp))
  return date.toLocaleString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  })
}

export const getMsalErrorMessage = (error: any) => {
  if (!error) return MSAL_ERROR_MESSAGES.unknown_error

  const code = error.errorCode || error.message || ''

  return MSAL_ERROR_MESSAGES[code] || `${MSAL_ERROR_MESSAGES.unknown_error}`
}

export default {
  getAllDistinctMimeTypes,
  sortByKeyDescending,
  formatDate,
  getMsalErrorMessage,
}
